/* eslint-disable import/order */
import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingServicedeskResolutionManagementRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskResolutionManagementRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

const ResolutionManagementRedirect = ({ match }: RouteContext): React.JSX.Element => (
	<Redirect to={`/jira/servicedesk/projects/${String(match.params.projectKey)}/settings/rovo`} />
);

export const projectSettingServicedeskResolutionManagementRouteEntry: ReturnType<
	typeof createEntry
> = createEntry(projectSettingServicedeskResolutionManagementRoute, () => ({
	group: 'project-settings-servicedesk',
	ufoName: 'jsm-rovo-service-agent-settings',
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdProjectSettings,
	},
	// eslint-disable-next-line no-restricted-syntax
	component: ResolutionManagementRedirect,

	resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
	perfMetricKey: 'jsm-resolution-management-settings',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
